// extracted by mini-css-extract-plugin
module.exports = {"footer-button-like":"AlertManagerFooterPause-module__footer-button-like__wGZa8"};